//本地导入
import axios from "axios";
import request, { getAppBaseApi, getHeaders } from "../request";

//客服列表
export const customerList = (data: any) =>
  request({
    data,
    method: "post",
    url: "/adm/customer/list",
  });

//保存客服
export const saveCustomer = (data: any) =>
  request({
    data,
    method: "post",
    url: "/adm/customer/save",
  });

//删除客服
export const removeCustomer = (data: any) =>
  request({
    data,
    method: "post",
    url: "/adm/customer/remove",
  });

//客服标签列表
export const customerTagList = (data: any) =>
  request({
    data,
    method: "post",
    url: "/adm/customer/tag/list",
  });

//保存客服标签
export const saveCustomerTag = (data: any) =>
  request({
    data,
    method: "post",
    url: "/adm/customer/tag/save",
  });

//删除客服标签
export const removeCustomerTag = (data: any) =>
  request({
    data,
    method: "post",
    url: "/adm/customer/tag/remove",
  });

//客服标签用户列表
export const customerTagUserList = (data: any) =>
  request({
    data,
    method: "post",
    url: "/adm/customer/tag/user/list",
  });

//保存客服标签用户
export const saveCustomerTagUser = (data: any) =>
  request({
    data,
    method: "post",
    url: "/adm/customer/tag/user/save",
  });

//删除客服标签用户
export const removeCustomerTagUser = (data: any) =>
  request({
    data,
    method: "post",
    url: "/adm/customer/tag/user/remove",
  });

//客服-评价-类型
export const customerCommentType = (data: any) =>
  request({
    data,
    method: "post",
    url: "/adm/customer/comment/type",
  });

//客服-评价-列表
export const customerCommentList = (data: any) =>
  request({
    data,
    method: "post",
    url: "/adm/customer/comment/list",
  });

//客服-评价-编辑
export const customerCommentEdit = (data: any) =>
  request({
    data,
    method: "post",
    url: "/adm/customer/comment/edit",
  });

//漂流瓶-列表
export const wishBottleList = (data: any) =>
  request({
    data,
    method: "post",
    url: "/adm/wish/bottle/list",
  });

//推广佣金Excel
export const customerCommentExpprt = (data: any) =>
  axios({
    data,
    method: "post",
    responseType: "blob",
    headers: getHeaders(),
    url: `${getAppBaseApi()}/adm/customer/comment/export`,
  });
